import React from 'react'
import ProfessionList from './List'
import { Layout } from 'antd'
import Header from '../Header'

const { Content } = Layout


const Profession = (props) => {
  return (
    <Layout className='layout'>
      <Header item='profession' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <ProfessionList />
        </div>
      </Content>
    </Layout>
  )
}
export default Profession
